import { motion } from "framer-motion";
import { useState } from "react";
import apiendspoint from "../apiendpoint.json";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { toast, ToastContainer } from "react-toastify";

// Labeled boxed field — fixed contrast + small accent nub
function Field({ label, type = "text", placeholder, value, onChange, error, textarea }) {
  const Tag = textarea ? "textarea" : "input";
  return (
    <div>
      {/* <label className="flex items-center gap-2 text-[11px] font-semibold tracking-wide uppercase text-slate-600 mb-2">
        <span className="w-1.5 h-1.5 rounded-full bg-emerald-500" />
        {label}
      </label> */}
      <Tag
        type={type}
        rows={textarea ? 3 : undefined}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className="w-full px-4 py-3 bg-slate-50 border-2 border-slate-200 rounded-xl text-sm text-slate-900 placeholder-slate-400
          shadow-sm outline-none transition-all resize-none
          focus:bg-white focus:border-emerald-500 focus:ring-4 focus:ring-emerald-100
          hover:border-slate-300"
      />
      {error && <p className="text-red-500 text-[11px] mt-1.5 font-medium">{error}</p>}
    </div>
  );
}

export default function Form({ animations = {} }) {
  const [isname, setName] = useState("");
  const [isPhone, setPhone] = useState("");
  const [isEmail, setEmail] = useState("");
  const [isMessage, setMessage] = useState("");
  const [isloading, setLoading] = useState(false);
  const [isEmailError, setEmailError] = useState("");
  const [isPhoneError, setPhoneError] = useState("");
  const [isNameError, setNameError] = useState("");


  const { executeRecaptcha } = useGoogleReCaptcha();

  const emailValidation = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const phoneValidation = /^(?:\+?\d{1,3}[ -]?)?(?:\d{3,5}[- ]?)?\d{10}$/;

  const validate = () => {
    let valid = true;
    if (!emailValidation.test(isEmail)) {
      setEmailError("Invalid email");
      valid = false;
    } else {
      setEmailError("");
    }
    if (!phoneValidation.test(isPhone)) {
      setPhoneError("Invalid phone number");
      valid = false;
    } else {
      setPhoneError("");
    }
    if (!isname.trim()) {
      setNameError("Name is required");
      valid = false;
    } else {
      setNameError("");
    }
    return valid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    if (!executeRecaptcha) {
      alert("reCAPTCHA is not ready. Please try again.");
      return;
    }

    setLoading(true);

    try {
      // Generate a fresh reCAPTCHA v3 token
      const captchaToken = await executeRecaptcha("contact_expert");
      // console.log("reCAPTCHA v3 Token:", captchaToken);
    
      

      if (!captchaToken) {
        alert("reCAPTCHA verification failed. Please try again.");
        setLoading(false);
        return;
      }

      const payload = {
        NameUser: isname,
        Email: isEmail,
        Message: isMessage,
        mobile: isPhone,
        recaptchaToken: captchaToken,
        action:"enquiry",
      };
      console.log(payload);
    
      const response = await fetch(`${apiendspoint.enquiryUrl}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          entity: "enquiry",
        },
        body: JSON.stringify(payload),
      });
      console.log(response.body);
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Form submission failed");
      }

      toast.success("Form submitted successfully!");
      setEmail("");
      setMessage("");
      setName("");
      setPhone("");
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <motion.div {...animations.formCard} className="lg:col-span-5 perspective-1000">
      <style>{`
        .nextera-glow-card {
          animation: nextera-glow-pulse 3.5s ease-in-out infinite alternate;
          transition: box-shadow 0.5s ease;
        }
        .nextera-glow-card:hover {
          animation-play-state: paused;
          box-shadow:
            0 0 0 1px rgba(16, 185, 129, 0.45),
            0 0 55px 10px rgba(20, 184, 166, 0.35),
            0 25px 50px -12px rgba(0, 0, 0, 0.25);
        }
        @keyframes nextera-glow-pulse {
          0% {
            box-shadow:
              0 0 0 1px rgba(16, 185, 129, 0.15),
              0 0 18px 2px rgba(16, 185, 129, 0.12),
              0 20px 45px -12px rgba(0, 0, 0, 0.15);
          }
          100% {
            box-shadow:
              0 0 0 1px rgba(20, 184, 166, 0.28),
              0 0 32px 6px rgba(20, 184, 166, 0.2),
              0 20px 45px -12px rgba(0, 0, 0, 0.18);
          }
        }
      `}</style>

      <div className="nextera-glow-card preserve-3d animate-float-card bg-white border border-slate-200 backdrop-blur-xl p-8 rounded-3xl relative overflow-hidden">
        {/* Top Accent Bar */}
        <div className="absolute top-0 left-0 right-0 h-1.5 bg-gradient-to-r from-emerald-500 via-teal-500 to-green-600" />

        <div className="flex items-center justify-between mb-6 pt-2">
          <h3 className="text-xl font-bold text-slate-900">
            Connect With An Expert
          </h3>
         
        </div>

        <form onSubmit={handleSubmit} className="space-y-5">
          <Field
            label="Full Name"
            placeholder="Full Name"
            value={isname}
            onChange={(e) => setName(e.target.value)}
            error={isNameError}
          />
          <Field
            label="Mobile Number"
            type="tel"
            placeholder="Mobile Number"
            value={isPhone}
            onChange={(e) => setPhone(e.target.value)}
            error={isPhoneError}
          />
          <Field
            label="Email Address"
            type="email"
            placeholder="Email Address"
            value={isEmail}
            onChange={(e) => setEmail(e.target.value)}
            error={isEmailError}
          />
          <Field
            label="Message"
            textarea
            placeholder="Tell us about your investment objectives..."
            value={isMessage}
            onChange={(e) => setMessage(e.target.value)}
          />

          {/* v3 reCAPTCHA runs invisibly in the background via executeRecaptcha */}

          <button
            type="submit"
            disabled={isloading}
            className={`w-full py-3.5 rounded-xl font-semibold text-sm tracking-wide transition-all shadow-md shadow-emerald-600/20
              ${isloading
                ? "bg-slate-200 text-slate-400 cursor-not-allowed shadow-none"
                : "bg-emerald-600 text-white hover:bg-emerald-700 hover:shadow-emerald-600/30 hover:-translate-y-0.5"
              }`}
          >
            {isloading ? "Sending..." : "Submit Request"}
          </button>
        </form>
      </div>

      <ToastContainer autoClose={3000} limit={2} hideProgressBar className="z-[9999] fixed top-28" />
    </motion.div>
  );
}